module.exports = __webpack_public_path__ + "img/q7.18a70f5a.png";